import React from 'react';
import PropTypes from 'prop-types';

const ICON_SIZE = 164;

function TowerIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={ICON_SIZE}
      height={ICON_SIZE}
      viewBox="0 0 164 164"
      className={className}
    >
      <path
        fill="#ccc"
        fillRule="evenodd"
        d="M82 40a8.2 8.2 0 015.4 14.4l23.6 83.2h45.7v3.6H7.3v-3.6H53l23.6-83.2A8.2 8.2 0 0182 40.1zm0 76.3l-21.8 20.4h43.6L82 116.3zM66.9 102l-9 31.7 21.4-20L67 102zm30.2 0l-12.4 11.7 21.4 20-9-31.7zM82 89L69.3 99.4 82 111.3l12.7-11.9L82 88.9zm9.3-7.6l-6.4 5.3L95 95l-3.8-13.7zm-18.6 0L69 95 79 86.6l-6.4-5.3zm9.3-12L74.6 78l7.4 6.1 7.4-6-7.4-9zM77.6 64l-2 7.1 4-4.7-2-2.4zm8.8 0l-2 2.4 4 4.7-2-7.1zM82 23.7a24.6 24.6 0 0114.9 44.2l-1-3.7c5.1-4 7-9.3 7-16a21 21 0 00-41.9 0c0 6.7 2 12 7.1 16l-1 3.6A24.6 24.6 0 0182 23.7zm0 20a4.6 4.6 0 00-2.4 8.5c.7.4 1 1.2.8 2l-1.6 5.6 3.2 3.8 3.2-3.7-1.6-5.7c-.2-.8 0-1.6.8-2a4.6 4.6 0 00-2.4-8.5zM82 31a17.3 17.3 0 0112.7 29l-1.2-4.3a13.7 13.7 0 10-25.2-7.4c0 3.5.8 5 2.2 7.5l-1.2 4.3A17.3 17.3 0 0182 31z"
      />
    </svg>
  );
}

TowerIcon.propTypes = {
  className: PropTypes.string,
};

TowerIcon.ICON_SIZE = ICON_SIZE;

export default TowerIcon;
